var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"basic-title-wrapper"},[_c('div',{staticClass:"title"},[(_vm.$slots.title)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.title))])],2),_c('div',{staticClass:"suffix"},[_vm._t("suffix")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }